export default __webpack_public_path__ + "static/tag-dont-1-light-c70e8a563f6bd5485e04ae67e2406bab.png";